export const sumArray = (array) => {
  return array.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
};

export const slugify = (str) => {
  return String(str)
    .toLowerCase()
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .replace('ð', 'd')
    .replace('ø', 'o')
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
};

export const shortenTeamName = (teamName) => {
  const targetTeamNames = [
    {
      name: 'IF Brommapojkarna',
      replacement: 'IFBP'
    }
  ];

  if (!targetTeamNames.find((item) => item.name === teamName)) return teamName;

  return targetTeamNames.find((item) => item.name === teamName).replacement;
}

export const textExcerpt = (str, maxLen = 100, separator = ' ') => {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen));
}
